/** Maximum lightening applied to shadow color in duotone bright-area fallback (no highlight color). */
export const DUOTONE_MAX_LIGHTEN = 0.5;
